import SectionHead from "./SectionHead";
import { testimonials } from "@/mocks/homeData";

const trustItems = [
  { icon: "ri-shield-user-line", title: "匿名保护", desc: "投稿不公开账号与身份，吃瓜也能安心发声。" },
  { icon: "ri-timer-flash-line", title: "快速审核", desc: "吧友审核团在线，1-2 小时完成过审上首页。" },
  { icon: "ri-team-line", title: "吧友共治", desc: "真实与趣味并重，社区规则由吧友共同维护。" },
  { icon: "ri-heart-line", title: "包容氛围", desc: "不同观点理性讨论，营造舒适的吃瓜环境。" },
];

export default function Trust() {
  return (
    <section id="trust" className="bg-foreground-950 py-16 md:py-24" aria-label="匿名保障与口碑">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="grid items-center gap-10 lg:grid-cols-[1fr_1.2fr] lg:gap-16">
          {/* 左侧：承诺 */}
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-500 px-4 py-1.5 text-xs font-bold uppercase tracking-widest text-foreground-950">
              <i className="ri-heart-2-fill text-sm" aria-hidden="true"></i>
              匿名保障与口碑
            </span>
            <h2 className="font-serifsc mt-5 text-3xl font-black tracking-tight text-background-50 md:text-4xl">
              放心投稿，
              <br />
              我们为你兜底
            </h2>
            <p className="mt-4 text-base leading-relaxed text-background-300 md:text-lg">
              在爆料吧，匿名不是口号而是底线。我们严格保护投稿人隐私，让每一份真实的声音都能被温柔对待，
              也让每一个吃瓜的人都能畅快围观。
            </p>
            <div className="mt-8 grid gap-4 sm:grid-cols-2">
              {trustItems.map((item) => (
                <div key={item.title} className="flex gap-3 rounded-xl bg-background-900/60 p-4">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary-500 text-white">
                    <i className={`${item.icon} text-xl`} aria-hidden="true"></i>
                  </span>
                  <div>
                    <h3 className="font-serifsc text-base font-bold text-background-50">{item.title}</h3>
                    <p className="mt-1 text-xs leading-relaxed text-background-300">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* 右侧：吧友口碑 */}
          <div className="flex flex-col gap-4">
            {testimonials.map((t) => (
              <figure key={t.name} className="rounded-2xl bg-background-100 p-6 md:p-7">
                <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500/90 px-3 py-1 text-xs font-bold text-foreground-950">
                  <i className="ri-verified-badge-fill text-sm" aria-hidden="true"></i>
                  {t.tag}
                </span>
                <blockquote className="mt-4 text-base leading-relaxed text-foreground-800">
                  “{t.quote}”
                </blockquote>
                <figcaption className="mt-5 flex items-center gap-3">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-500 font-serifsc text-sm font-bold text-white">
                    {t.name.charAt(0)}
                  </span>
                  <div>
                    <p className="text-sm font-bold text-foreground-950">{t.name}</p>
                    <p className="text-xs text-foreground-500">{t.role}</p>
                  </div>
                  <i className="ri-double-quotes-r ml-auto text-3xl text-background-300" aria-hidden="true"></i>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}